import PageServicesFactory from '../../page/Services/factory.js'
import DealerEntitiesFactory from '../Entities/factory.js'
import {DealerRequestsFactory} from '../Requests/factory.js'
import {LocationMappersFactory} from './../../location/Mappers/factory.js'
import {LocationValueObjectsFactory} from './../../location/ValueObjects/factory.js'
import DealerValueObjectsFactory from './../ValueObjects/factory.js'
import ContractRawDataToContractEntityDealerMapper from './ContractRawDataToContractEntityDealerMapper.js'
import {FromDealerLocationJsonToLocationValueObjectMapper} from './FromDealerLocationJsonToLocationValueObjectMapper.js'
import {FromDealerRawDataToDealerEntityMapper} from './FromDealerRawDataToDealerEntityMapper.js'
import {FromDealersListJSONtoUrlVOMapper} from './FromDealersListJSONtoUrlVOMapper.js'
import {FromDealersListRawDataToDealersListValueObjectMapper} from './FromDealersListRawDataToDealersListValueObjectMapper.js'
import {FromParamsToTrackingPhoneRequestParamsValueObjectMapper} from './FromParamsToTrackingPhoneRequestParamsValueObjectMapper.js'
import {FromSearchToSearchResultsDealerRequestMapper} from './FromSearchToSearchResultsDealerRequestMapper.js'
import {FromVehicleConfiguratorDealerRawDataToDealerEntityMapper} from './FromVehicleConfiguratorDealerRawDataToDealerEntityMapper.js'

export default class DealerMappersFactory {
  static contractRawDataToContractEntityDealerMapper = ({config}) =>
    new ContractRawDataToContractEntityDealerMapper({
      config,
      entityFactory: DealerEntitiesFactory.contractEntity
    })

  /**
   * @return {FromDealerLocationJsonToLocationValueObjectMapper}
   */
  static fromDealerLocationJsonToLocationValueObjectMapper = ({config}) =>
    new FromDealerLocationJsonToLocationValueObjectMapper({
      config,
      locationValueObjectFactory: LocationValueObjectsFactory.locationValueObject,
      fromJsonToGoogleMapsApiUrlsMapper: LocationMappersFactory.fromJsonToGoogleMapsApiUrlsMapper({config})
    })

  /**
   * @return {FromDealerRawDataToDealerEntityMapper}
   */
  static fromDealerRawDataToDealerEntityMapper = ({config}) =>
    new FromDealerRawDataToDealerEntityMapper({
      config,
      dealerEntityFactory: DealerEntitiesFactory.dealerEntity,
      dealerServiceValueObjectFactory: DealerValueObjectsFactory.dealerServiceValueObject,
      fromDealerLocationJsonToLocationValueObjectMapper:
        DealerMappersFactory.fromDealerLocationJsonToLocationValueObjectMapper({
          config
        }),
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  static fromVehicleConfiguratorDealerRawDataToDealerEntityMapper = ({config}) =>
    new FromVehicleConfiguratorDealerRawDataToDealerEntityMapper({
      config,
      dealerEntityFactory: DealerEntitiesFactory.dealerEntity,
      dealerServiceValueObjectFactory: DealerValueObjectsFactory.dealerServiceValueObject,
      fromDealerLocationJsonToLocationValueObjectMapper:
        DealerMappersFactory.fromDealerLocationJsonToLocationValueObjectMapper({
          config
        }),
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  /**
   * @return {FromDealersListRawDataToDealersListValueObjectMapper}
   */
  static fromDealersListRawDataToDealersListValueObjectMapper = ({config}) =>
    new FromDealersListRawDataToDealersListValueObjectMapper({
      config,
      dealersListValueObjectFactory: DealerValueObjectsFactory.dealersListValueObject,
      fromDealerRawDataToDealerEntityMapper: DealerMappersFactory.fromDealerRawDataToDealerEntityMapper({config})
    })

  /**
   * @return {FromSearchToSearchResultsDealerRequestMapper}
   */
  static fromSearchToSearchResultsDealerRequestMapper = ({config}) =>
    new FromSearchToSearchResultsDealerRequestMapper({
      config,
      searchResultsDealerRequest: DealerRequestsFactory.searchResultsDealerRequest
    })

  static fromParamsToTrackingPhoneRequestParamsValueObjectMapper = ({config}) =>
    new FromParamsToTrackingPhoneRequestParamsValueObjectMapper({
      config,
      trackingPhoneRequestParamsValueObjectFactory:
        DealerValueObjectsFactory.trackingPhoneRequestParamsDealerValueObject
    })

  static fromDealersListJSONtoUrlVOMapper = ({config}) =>
    new FromDealersListJSONtoUrlVOMapper({
      config
    })
}
